import { render } from "./agenda.vue?vue&type=template&id=4fcf32df&scoped=true"
import script from "./agenda.vue?vue&type=script&lang=js"
export * from "./agenda.vue?vue&type=script&lang=js"

import "./agenda.vue?vue&type=style&index=0&id=4fcf32df&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4fcf32df"

export default script